import { FC } from 'react';
import { Input } from 'antd';

import { useAntDesignTheme } from '@/hooks/useAntDesignTheme';
import { PlatformForm as Form } from '@/shared/components/forms';

const DeveloperInformationSection: FC = () => {
    const { token } = useAntDesignTheme();
    const label = (text: string) => <small style={{ color: token.colorTextTertiary }}>{text}</small>;

    return (
        <>
            <Form.Item label={label('Developer Name')} name='developerName'>
                <Input placeholder='Acme Corporation...' />
            </Form.Item>
            <Form.Item
                label={label('Support Email')}
                name='supportEmail'
                rules={[{ type: 'email', message: 'Enter a valid support email' }]}
            >
                <Input placeholder='support@example.com...' />
            </Form.Item>
            <Form.Item
                label={label('Support / Documentation URL')}
                name='supportURL'
                rules={[{ type: 'url', message: 'Enter a valid URL' }]}
            >
                <Input placeholder='https://example.com/support...' />
            </Form.Item>
            <Form.Item
                label={label('Website URL')}
                name='websiteUrl'
                rules={[{ type: 'url', message: 'Enter a valid URL' }]}
            >
                <Input placeholder='https://example.com...' />
            </Form.Item>
            <Form.Item
                label={label('Installation URL')}
                name='installationUrl'
                rules={[{ type: 'url', message: 'Enter a valid URL' }]}
            >
                <Input placeholder='https://example.com/install...' />
            </Form.Item>
        </>
    );
};

export default DeveloperInformationSection;
